'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense, useEffect, useRef, useState } from 'react';
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
import type { GeoLocationDto } from '@sola/skippy-search-sdk/lib/schema.ts';
import { useResolveLocation } from './volunteer-controls.logic.ts';
import { VolunteerFilter } from './volunteer-filter.tsx';
import { VolunteerList } from './volunteer-list.tsx';
const VolunteerFilterSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="body-md md:align-center"><Skeleton height={20} width={120} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="VolunteerFilter"><div className="VolunteerFilter__container flex flex-col md:flex-row md:justify-between md:align-center gap-comfy-lg">{t0}<div className="flex align-end md:justify-end md:align-center gap-comfy-sm"><Skeleton height={40} width={140} borderRadius="0.5rem" /><Skeleton height={40} width={80} borderRadius="0.5rem" /></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
type VolunteerControlsProps = {
  seoLevel?: number;
  q?: string;
  limit?: number;
  variant: 'default' | 'tour';
  slug?: string;
};
export const VolunteerControls = t0 => {
  const $ = _c(23);
  const {
    seoLevel,
    q,
    limit,
    variant,
    slug
  } = t0;
  const [volunteerCount, setVolunteerCount] = useState();
  const [geoCoords, setGeoCoords] = useState();
  const hasUserClearedRef = useRef(false);
  const {
    resolved,
    isResolving
  } = useResolveLocation();
  const prevResolvedRef = useRef(resolved);
  let t1;
  let t2;
  if ($[0] !== geoCoords || $[1] !== resolved) {
    t1 = () => {
      if (!resolved || hasUserClearedRef.current) {
        return;
      }
      if (resolved !== prevResolvedRef.current) {
        prevResolvedRef.current = resolved;
        setGeoCoords(resolved.geo);
      } else {
        if (!geoCoords) {
          setGeoCoords(resolved.geo);
        }
      }
    };
    t2 = [resolved, geoCoords];
    $[0] = geoCoords;
    $[1] = resolved;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = t4 => {
      const {
        totalCount
      } = t4;
      setVolunteerCount(totalCount);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onVolunteerLoad = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = newGeo => {
      hasUserClearedRef.current = !newGeo;
      setGeoCoords(newGeo);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleGeoChange = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <VolunteerFilterSkeleton />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== limit || $[8] !== resolved || $[9] !== variant || $[10] !== volunteerCount) {
    t6 = <Suspense fallback={t5}><VolunteerFilter volunteerCount={volunteerCount} limit={limit} defaultLocation={resolved} onGeoChange={handleGeoChange} variant={variant} /></Suspense>;
    $[7] = limit;
    $[8] = resolved;
    $[9] = variant;
    $[10] = volunteerCount;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = isResolving ? undefined : geoCoords;
  let t8;
  if ($[12] !== isResolving || $[13] !== limit || $[14] !== q || $[15] !== seoLevel || $[16] !== slug || $[17] !== t7 || $[18] !== variant) {
    t8 = <VolunteerList seoLevel={seoLevel} q={q} limit={limit} variant={variant} slug={slug} onVolunteerLoad={onVolunteerLoad} isDynamic={true} geoCoords={t7} isLocationResolving={isResolving} />;
    $[12] = isResolving;
    $[13] = limit;
    $[14] = q;
    $[15] = seoLevel;
    $[16] = slug;
    $[17] = t7;
    $[18] = variant;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <div className="grid gap-comfy-xl md:gap-roomy-xs">{t6}{t8}</div>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};